import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import URL from '../../../constants/url';
import style from './HealthInfoDetail.module.css';

import axiosApi from '../../../api/daonAxios';

import { createPortal } from 'react-dom';

const MIN_SKELETON_MS = 300;   // 스켈레톤 최소 노출 시간

const HealthInfoDetail = ({ contId, onClose }) => {
    const navigate = useNavigate();
    // const location = useLocation();
    // const { state } = location;
    // const [searchParams] = useSearchParams();

    const [contents, setContents] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const loadingTimerRef = useRef(null);
    useEffect(() => () => clearTimeout(loadingTimerRef.current), []);

    // effect deps 오염 방지 — 부모 리렌더로 onClose identity 가 바뀌어도 재구독 안 함
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    // useEffect(() => {
    //     const paramId = searchParams.get("contId")

    //     if (state === null && paramId === null) {      
    //         alert("잘못된 접근 입니다.");
    //         navigate(URL.HEALTH_INFORM);
    //     } else {
    //         if(state !== null) {
    //             getContent(state.id);
    //         } else {
    //             getContent(paramId);
    //         }      
    //     }
    // }, [state, navigate]);

    
    const getContent = useCallback((id, showSkeleton = true) => {
        
        const jToken = localStorage.getItem("jToken");

        const startedAt = Date.now();
        if (showSkeleton) setIsLoading(true);

        const requestOptions = {
            params : {
                contId : id,
            },
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }
        axiosApi.get(`/healthContent/detail`,requestOptions).then((res) => {
           const result = res.data.result;
            setContents(result);

            // 스켈레톤이 떠 있는 동안 이미지를 미리 받아둔다
            if (result?.cntsImgUrl) {
                const img = new Image();
                img.src = result.cntsImgUrl;
            }     
            
        }).catch(error => {
            console.error(error);
        }).finally(()=> {
            if (!showSkeleton) return;

            // 응답이 빨라도 최소 시간은 스켈레톤 유지
            const remain = Math.max(0, MIN_SKELETON_MS - (Date.now() - startedAt));

            clearTimeout(loadingTimerRef.current);
            loadingTimerRef.current = setTimeout(() => setIsLoading(false), remain);
        })
    }, [])

    useEffect(() => {
        if (!contId) return;
        getContent(contId);
    }, [contId, getContent]);


    // 팝업이 떠 있는 동안 배경 스크롤 잠금
    useEffect(() => {
        const { body } = document;
        const scrollY = window.scrollY;

        const prev = {
            position: body.style.position,
            top: body.style.top,
            left: body.style.left,
            width: body.style.width,
            overflow: body.style.overflow,
        };

        body.style.position = 'fixed';
        body.style.top = `-${scrollY}px`;
        body.style.left = '0';
        body.style.width = '100%';
        body.style.overflow = 'hidden';

        return () => {
            Object.assign(body.style, prev);
            window.scrollTo(0, scrollY);   // 닫을 때 원래 위치 복원
        };
    }, []);

    
    const handleCheckBkmk = (e, contId, bkmkId) => {
        
        const jToken = localStorage.getItem("jToken");

        const requestOptions = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }

        const params = {
            // cntntsId : contId,
            // bkmkId : bkmkId,
            cntsId : contId,
            useAt : e.target.checked ? '1' : '0',
        };

        // 최초 등록이면 bkmkId 가 없다
        if (bkmkId != null && bkmkId !== '') {
            params.bkmkId = bkmkId;
        }
        axiosApi.post('/healthContent/bookmark',params,requestOptions)
        .then((res) => {
           getContent(contId, false);   // 북마크 갱신은 스켈레톤 없이
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
        })
    }

    const handleLikeClick = (contId, likeInfoId, likeType) => {
        const jToken = localStorage.getItem("jToken");

        const requestOptions = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }

        const params = {
            cntntsId : contId,
            likeInfoId : likeInfoId,
            likeTy : likeType,
        };
        axiosApi.post('/healthContent/like',params,requestOptions)
        .then((res) => {
            getContent(contId);
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
        })
    }

    /* ── 로딩 스켈레톤 ── */
    // if (isLoading) {
    //     return (
    //         <div className={style.popupLayout}>
    //             <HeadSub title="건강정보" onBack={onClose} />
    //             <div className={style.popupBody}>

    //                 <div className={style.topTxtBox}>
    //                     <strong></strong>
    //                     <p></p>
    //                 </div>
                    
    //                 <div className={style.skeletonImage} aria-hidden="true" />

    //                 <ul className={style.imgTxtBox}>
    //                     {[0, 1, 2, 3, 4, 5].map((i) => (
    //                         <li key={i}></li>
    //                     ))}
    //                 </ul>

                    
    //             </div>
    //         </div>
    //     );
    // }


    if (!contents) {
        return (
           
            <div className={style.popupLayout}>
                <HeadSub title="건강정보" onBack={onClose} />
                <div className={style.errorWrap}>
                    <p>콘텐츠를 찾을 수 없습니다.</p>
                    <button className={style.backBtn} onClick={onClose}>
                        목록으로 돌아가기
                    </button>
                </div>
            </div>
        );
    }

    return createPortal(
        <div className={style.popupLayout}>
            <HeadSub
                title="건강정보"
                onBack={onClose}
                rightArea={
                    <div className={style.bookmarkBox}>
                        <input
                            type="checkbox"
                            id="detail_bkmk"
                            checked={contents.bkmkUseAt === '1' ? true : false}
                            onChange={(e) => handleCheckBkmk(e, contents.id, contents.bkmkId)}
                        />
                        <label htmlFor="detail_bkmk" />
                    </div>
                }
            />

            <div className={style.popupBody}>
                <div className={style.contentImage}>
                    <img src={contents.cntsImgUrl} alt={contents.cntsSj} draggable={false} />
                </div>
            </div>
        </div>,
        document.body
    );
};

export default HealthInfoDetail;
